import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const DependencyStatusHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title="It affects how much you can borrow">
    Independent students can borrow more but you will have to prove in your FAFSA application, that you are dependent.
    Here's a primer: <a href="https://studentaid.ed.gov/sa/sites/default/files/fafsa-dependency.pdf" target="_blank"
                        rel="noopener noreferrer">Am I Dependent or Independent?</a>
  </HelpModal>